import './document.css';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../../../context/LanguageContext';
import { normalizeSupportedLanguage } from '../../../../utils/createScopedI18n';
import { documentDeliveryI18n } from './i18n';

export default function DocumentViewModal({ Modal, show, record, onClose }) {
  const { language } = useLanguage();
  const documentsLanguage = normalizeSupportedLanguage(language);
  const { t } = useTranslation(undefined, { i18n: documentDeliveryI18n });

  useEffect(() => {
    documentDeliveryI18n.changeLanguage(documentsLanguage);
  }, [documentsLanguage]);

  if (!Modal) return null;
  if (!show || !record) return null;

  const title = record.name || t('doc_delivery_modal_view_default_title');
  const serviceLabel =
    record.serviceName || record.service || t('doc_delivery_modal_view_no_service');
  const areaLabel = record.areaName || record.area || '';

  return (
    <Modal
      title={title}
      show={show}
      onClose={onClose}
      primaryBtnTxt={t('doc_delivery_modal_view_close')}
      primaryBtnAction={onClose}
      secondaryBtnTxt={null}
      width={960}
      height='80vh'
    >
      <div className='d-flex flex-column gap-3' style={{ maxHeight: '72vh' }}>
        {/* Meta info */}
        <div className='mini color-gray-600'>
          <div>
            <span className='fw-semibold'>{t('doc_delivery_modal_view_service')} </span>
            <span>{serviceLabel}</span>
          </div>
          {areaLabel && (
            <div>
              <span className='fw-semibold'>{t('doc_delivery_modal_view_area')} </span>
              <span>{areaLabel}</span>
            </div>
          )}
        </div>

        <hr className='my-2' />

        {/* Preview content */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: 16,
            borderRadius: 12,
            border: '1px solid #e6e8eb',
            background: '#ffffff',
          }}
        >
          {record.content ? (
            <div
              className='document-preview-content'
              dangerouslySetInnerHTML={{ __html: record.content }}
            />
          ) : (
            <p className='caption font-light'>
              {t('doc_delivery_modal_view_empty_content')}
            </p>
          )}
        </div>
      </div>
    </Modal>
  );
}
